function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodRoomServiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.936 6.097a4.719 4.719 0 014.605 3.712h-9.21a4.719 4.719 0 014.605-3.712zm8.02 5.712v-2h-1.392a6.715 6.715 0 00-5.628-5.63V2.5h-2v1.68a6.715 6.715 0 00-5.63 5.63H9.915v2h16.042zm.98 15.69a1.001 1.001 0 010-2 1.001 1.001 0 010 2zm-19-1a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm0-3h18v-8.16h-18v8.16zm20 .185V14.34a1 1 0 00-1-1h-19V8.086L3.643 3.793 2.23 5.207l3.707 3.707v14.77a2.996 2.996 0 00-2 2.816c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h14.37a2.938 2.938 0 00-.184 1c0 1.654 1.345 3 3 3 1.653 0 3-1.346 3-3a2.996 2.996 0 00-2-2.816z",
    fill: props.color
  }));
}

export default SvgIconFoodRoomServiceFilled;